import React, { useEffect, useRef, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import ApplicationLayout from "../../../layouts/ApplicationLayout";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { IAM_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import { useSelector } from "react-redux";
import RunningStatusViewModal from "../../assets/action/serviceChecksheet/runningStatus/RunningStatusViewModal";
import { toast } from "react-toastify";
import Loader from "../../../components/ui/Loader/Loader";
import api from "../../../services/api";
import TapIcon from "../../../services/TapIcon";
import TapSelect from "../../../components/ui/TapSelect";
import { DisplaySearchCriteria } from "../../../components/TapUi/index";
import ScsEventListModal from "./ScsEventListModal";
import ComplianceEventListModal from "./ComplianceEventListModal";
import PoEventListModal from "./PoEventListModal";
import TicketsEventListModal from "./TicketsEventListModal";
import ProjectTicketsEventListModal from "./ProjectTicketsEventListModal";
import RentalEventListModal from "./RentalEventListModal";
import EmployeeComplianceEventListModal from "./EmployeeComplianceEventListModal";
import DateService from "../../../services/DateService";

const ActivityCalendar = (props) => {
    const calender_url                      =   IAM_API_BASE_URL_2 + '/report/activity_calendar';
    const RunningStatusModalRef             =   useRef(null);
    const ComplianceModalRef                =   useRef(null);
    const PoModalRef                        =   useRef(null);
    const localizer                         =   momentLocalizer(moment);
    const accessToken                       =   useSelector(state => state.auth.access_token);
    const iam_user_sites                    =   useSelector(state => state.app.user_sites || []);

    const [currentView, setCurrentView]                             =  useState('month');
    const [currentDate, setCurrentDate]                             =  useState(new Date());
    const [visibleRange, setVisibleRange]                           =  useState(null);
    const [loading, setLoading]                                     =  useState(false);
    const [allEvents, setAllEvents]                                 =  useState([]);
    const [scsUpdatedTime, setScsUpdatedTime]                       =  useState('');
    const [filterFormVisible, setFilterFormVisible]                 =  useState(false);
    const [reportSubmitted, setReportSubmitted]                     =  useState(true);
    const [formSearchedElems, setFormSearchedElems]                 =  useState([]);
    const [showScsModal, setShowScsModal]                           =  useState(false);
    const [selectedScsDate, setSelectedScsDate]                     =  useState(null);
    const [scsStartDate, setScsStartDate]                           =  useState(null);
    const [scsEndDate, setScsEndDate]                               =  useState(null);
    const [selectedSummaryDate, setSelectedSummaryDate]             =  useState(null);
    const [rental_listing, setRental_listing]                       =  useState([]);
    const [showComplianceModal, setShowComplianceModal]             =  useState(false);
    const [selectedComplianceDate, setSelectedComplianceDate]       =  useState(null);
    const [employeeCompliance_listing, setEmployeeCompliance_listing] = useState([]);
    const [showPoModal, setShowPoModal]                             = useState(false);
    const [selectedPoDate, setSelectedPoDate]                       = useState(null);
   const [selectedRentalType, setSelectedRentalType] = useState(null);

    
    const [showTicketsModal, setShowTicketsModal] = useState(false);
    const [selectedTicketsDate, setSelectedTicketsDate] = useState(null);
    const [showProjectTicketsModal, setShowProjectTicketsModal] = useState(false);
    const [selectedProjectTicketsDate, setSelectedProjectTicketsDate] = useState(null);
    const [showRentalModal, setShowRentalModal] = useState(false);
    const [selectedRentalDate, setSelectedRentalDate] = useState(null);
    const [showEmployeeComplianceModal, setShowEmployeeComplianceModal] = useState(false);
    const [selectedEmployeeComplianceDate, setSelectedEmployeeComplianceDate] = useState(null);
    const [formData, setFormData] = useState({
        allSites: [],
        filterData: {
            search_site_ids: [],
        }
    });

    const reportFilterFormLabel = {
        'search_site_ids': 'Site : ',
    };

    useEffect(() => {
        setFormData(pre => ({
            ...pre,
            allSites: iam_user_sites.map(w => ({ value: w.id, label: `${w.site_name} (${w.site_code})` }))
        }));
    }, [iam_user_sites]);

    useEffect(() => {
        if (visibleRange && visibleRange.start && visibleRange.end) {
            loadCalendarData(visibleRange.start, visibleRange.end);
        }
    }, [visibleRange]);

    useEffect(() => {
        calculateVisibleRange(currentDate, currentView);
    }, [currentDate, currentView]);

    const calculateVisibleRange = (date, view) => {
        const momentDate = moment(date);
        let start, end;

        if (view === 'month') {
            start = momentDate.clone().startOf('month').startOf('week');
            end = momentDate.clone().endOf('month').endOf('week');
        } else if (view === 'week') {
            start = momentDate.clone().startOf('week');
            end = momentDate.clone().endOf('week');
        } else {
            start = momentDate.clone().startOf('day');
            end = momentDate.clone().endOf('day');
        }
        setVisibleRange({ start, end });
    };

    const onRangeChange = (range) => {
        let start, end;

        if (Array.isArray(range)) {
            if (range.length > 0) {
                start = moment(range[0]).startOf('day');
                end = moment(range[range.length - 1]).endOf('day');
            }
        }
        else if (range.start && range.end) {
            start = moment(range.start).startOf('day');
            end = moment(range.end).endOf('day');
        }
        else if (range) {
            start = moment(range).startOf('day');
            end = moment(range).endOf('day');
        }

        if (start && end) {
            setVisibleRange({ start, end });
        }
    };

    const loadCalendarData = async (startDate, endDate) => {
        if (!startDate || !endDate) return;

        const params = {
            search_date_from:  DateService.dateFormat(startDate, 'YYYY-MM-DD'),
            search_date_to: DateService.dateFormat(endDate, 'YYYY-MM-DD'),
            per_page: 200,
            search_site_ids: formData.filterData.search_site_ids
        };

        let headers = { 'Authorization': 'Bearer ' + accessToken };

        setLoading(true);
        try {
            const response = await api.server2Api.get(calender_url, { params: params, headers: headers });
            setScsUpdatedTime(response.data?.scs_updated_time || '');

            const events = [];

            // SCS Events
            Object.keys(response.data?.scs_running_status_data || {}).forEach(date => {
                const count = response.data.scs_running_status_data[date];
                if (count > 0) {
                    events.push({
                        id: `scs-${date}`,
                        title: `SCS: ${count}`,
                        start: moment(date).toDate(),
                        end: moment(date).add(1, 'hour').toDate(),
                        eventType: 'scs',
                        date: date
                    });
                }
            });

            // Compliance Events
            Object.keys(response.data?.asset_compliance_data || {}).forEach(date => {
                const count = response.data.asset_compliance_data[date];
                if (count > 0) {
                    events.push({
                        id: `compliance-${date}`,
                        title: `Asset Compliance: ${count}`,
                        start: moment(date).toDate(),
                        end: moment(date).add(1, 'hour').toDate(),
                        eventType: 'compliance',
                        date: date
                    });
                }
            });

            // PO Events
            Object.keys(response.data?.po_data || {}).forEach(date => {
                const count = response.data.po_data[date];
                if (count > 0) {
                    events.push({
                        id: `po-${date}`,
                        title: `PO: ${count}`,
                        start: moment(date).toDate(),
                        end: moment(date).add(1, 'hour').toDate(),
                        eventType: 'po',
                        date: date
                    });
                }
            });

            // Tickets Events
            Object.keys(response.data?.tickets_data || {}).forEach(date => {
                const count = response.data.tickets_data[date];
                if (count > 0) {
                    events.push({
                        id: `tickets-${date}`,
                        title: `Tickets: ${count}`,
                        start: moment(date).toDate(),
                        end: moment(date).add(1, 'hour').toDate(),
                        eventType: 'tickets',
                        date: date
                    });
                }
            });

            // Project Tickets Events
            Object.keys(response.data?.project_tickets_data || {}).forEach(date => {
                const count = response.data.project_tickets_data[date];
                if (count > 0) {
                    events.push({
                        id: `project-tickets-${date}`,
                        title: `Project Tickets: ${count}`,
                        start: moment(date).toDate(),
                        end: moment(date).add(1, 'hour').toDate(),
                        eventType: 'project_tickets',
                        date: date
                    });
                }
            });

            // Rental Events
            if (response.data?.rental_data && response.data.rental_data.length > 0) {
                const rentalType = {};
                response.data.rental_data.forEach(item => {
                    const date = item.date;
                    const type = item.type;
                    const total = item.total;

                    if (!rentalType[date]) {
                        rentalType[date] = {};
                    }

                    rentalType[date][type] = total;
                });

                Object.keys(rentalType).forEach(date => {
                    const typesData = rentalType[date];
                    Object.keys(typesData).forEach(type => {
                        const count = typesData[type];
                        let displayTitle = '';
                        let eventType = '';

                        if (type == 'date_release_tentative') {
                            displayTitle = `Release Date: ${count}`;
                            eventType = 'tentative';
                        } else if (type == 'wo_due_date') {
                            displayTitle = `WO Due Date: ${count}`;
                            eventType = 'wo_due_date';
                        } 

                        events.push({
                            id: `${eventType}-${date}-${type}`,
                            title: displayTitle,
                            start: moment(date).toDate(),
                            end: moment(date).add(1, 'hour').toDate(),
                            eventType: eventType,
                            date: date,
                            rentalType: type,
                            rentalDetails: typesData
                        });
                    });
                });
            }

            if (response.data?.employee_compliance_data && response.data.employee_compliance_data.length > 0) {
                const employeeComplianceByDate = {};
                response.data.employee_compliance_data.forEach(item => {
                    const date = item.date;
                    const count = item.total_compliance || 0;
                        employeeComplianceByDate[date] = count;
                    
                });

                Object.keys(employeeComplianceByDate).forEach(date => {
                    const count = employeeComplianceByDate[date];
                    if (count > 0) {
                        events.push({
                            id: `employee-compliance-${date}`,
                            title: `Employee Compliance: ${count}`,
                            start: moment(date).toDate(),
                            end: moment(date).add(1, 'hour').toDate(),
                            eventType: 'employee_compliance',
                            date: date
                        });
                    }
                });
            }

            setAllEvents(events);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };

    const handleBack = () => {
        let newDate;
        if (currentView === 'month') {
            newDate = moment(currentDate).subtract(1, 'month').toDate();
        } else if (currentView === 'week') {
            newDate = moment(currentDate).subtract(1, 'week').toDate();
        } else {
            newDate = moment(currentDate).subtract(1, 'day').toDate();
        }
        setCurrentDate(newDate);
    };

    const handleNext = () => {
        let newDate;
        if (currentView === 'month') {
            newDate = moment(currentDate).add(1, 'month').toDate();
        } else if (currentView === 'week') {
            newDate = moment(currentDate).add(1, 'week').toDate();
        } else {
            newDate = moment(currentDate).add(1, 'day').toDate();
        }
        setCurrentDate(newDate);
    };

    const onViewChange = (view) => {
        setCurrentView(view);
    };

    const onNavigate = (newDate) => {
        setCurrentDate(newDate);
    };

    const handleEventClick = (event) => {

        let startDate, endDate;
        if (visibleRange && visibleRange.start && visibleRange.end) {
            startDate = visibleRange.start;
            endDate = visibleRange.end;
        } else {
            startDate = moment(event.start);
            endDate = moment(event.start);
        }

        if (event.eventType === 'scs') {
            setSelectedScsDate(event.date);
            setScsStartDate(startDate);
            setScsEndDate(endDate);
            setShowScsModal(true);
        }
        else if (event.eventType === 'compliance') {
            setSelectedComplianceDate(event.date);
            setScsStartDate(startDate);
            setScsEndDate(endDate);
            setShowComplianceModal(true)
        }
        else if (event.eventType === 'tentative' || event.eventType === 'wo_due_date') {
            setSelectedRentalType(event.eventType);
            setSelectedRentalDate(event.date);
            setScsStartDate(startDate);
            setScsEndDate(endDate);
            setShowRentalModal(true);
        }
        else if (event.eventType === 'po') {
            setSelectedPoDate(event.date);
            setScsStartDate(startDate);
            setScsEndDate(endDate);
            setShowPoModal(true);
        }
        else if (event.eventType === 'tickets') {
            setSelectedTicketsDate(event.date);
            setScsStartDate(startDate);
            setScsEndDate(endDate);
            setShowTicketsModal(true);
        }
        else if (event.eventType === 'project_tickets') {
            setSelectedProjectTicketsDate(event.date);
            setScsStartDate(startDate);
            setScsEndDate(endDate);
            setShowProjectTicketsModal(true);
        }
        else if (event.eventType === 'employee_compliance') {
            setSelectedEmployeeComplianceDate(event.date);
            setScsStartDate(startDate);
            setScsEndDate(endDate);
            setShowEmployeeComplianceModal(true);
        }
        else {
            toast.info(`${event.eventType.toUpperCase()} details for ${moment(event.date).format('DD MMM YYYY')} - Coming soon`);
        }
    };

    const getDateWiseSummary = () => {
        const summary = {};

        allEvents.forEach(event => {
            const dateKey = moment(event.start).format("YYYY-MM-DD");

            if (!summary[dateKey]) {
                summary[dateKey] = {
                    date: dateKey,
                    scs: 0,
                    compliance: 0,
                    po: 0,
                    tickets: 0,
                    project_tickets: 0,
                     tentative: 0,
                    wo_due_date: 0,
                    employee_compliance: 0
                };
            }

            if (summary[dateKey][event.eventType] !== undefined) {
                const count = parseInt(event.title.split(": ")[1]) || 0;
                summary[dateKey][event.eventType] += count;
            }
        });

        return Object.values(summary).sort(
            (a, b) => moment(b.date).unix() - moment(a.date).unix()
        );
    };

    const handleSummaryClick = (type, date, count) => {
        if (count <= 0) return;

        let startDate, endDate;

        if (visibleRange && visibleRange.start && visibleRange.end) {
            startDate = visibleRange.start;
            endDate = visibleRange.end;
        } else {
            startDate = moment(date);
            endDate = moment(date);
        }

        if (type === 'scs') {
            setSelectedScsDate(date);
            setScsStartDate(startDate);
            setScsEndDate(endDate);
            setShowScsModal(true);
        } else if (type === 'compliance') {
            setSelectedComplianceDate(date);
            setScsStartDate(startDate);
            setScsEndDate(endDate);
            setShowComplianceModal(true);
        } else if (type === 'po') {
            setSelectedPoDate(date);
            setScsStartDate(startDate);
            setScsEndDate(endDate);
            setShowPoModal(true);
        }
        else if (type === 'tickets') {
            setSelectedTicketsDate(date);
            setScsStartDate(startDate);
            setScsEndDate(endDate);
            setShowTicketsModal(true);
        } else if (type === 'project_tickets') {
            setSelectedProjectTicketsDate(date);
            setScsStartDate(startDate);
            setScsEndDate(endDate);
            setShowProjectTicketsModal(true);
        } else if (type === 'tentative' || type === 'wo_due_date' ){
            setSelectedRentalDate(date);
             setSelectedRentalType(type);
            setScsStartDate(startDate);
            setScsEndDate(endDate);
            setShowRentalModal(true);
        } else if (type === 'employee_compliance') {
            setSelectedEmployeeComplianceDate(date);
            setScsStartDate(startDate);
            setScsEndDate(endDate);
            setShowEmployeeComplianceModal(true);
        } else {
            toast.info(
                `${type.replaceAll('_', ' ').toUpperCase()} details for ${moment(date).format('DD MMM YYYY')} - Coming soon`
            );
        }
    };

    const reportFilterFormSubmit = (event = null) => {
        event && event.preventDefault();

        let searchedElems = [];
        if (formData.filterData.search_site_ids && formData.filterData.search_site_ids.length > 0) {
            const show_val = formData.allSites
                .filter((s) => formData.filterData.search_site_ids.includes(s.value))
                .map(s => s.label)
                .join(', ');
            searchedElems.push(`${reportFilterFormLabel['search_site_ids']} <b>${show_val}</b>`);
        }

        setFormSearchedElems(searchedElems);
        setReportSubmitted(true);
        setFilterFormVisible(false);

        if (visibleRange && visibleRange.start && visibleRange.end) {
            loadCalendarData(visibleRange.start, visibleRange.end);
        }
    };

    const toggleFilterForm = (show) => {
        setFilterFormVisible(show);
    };

    const pageTitleBarJsx = () => {
        return (
            <div className="page_title row m0">
                <div className="col-sm-12 px-2">
                    <div className="d-flex align-items-center justify-content-between">
                        <h3><TapIcon.FontAwesomeIcon icon={TapIcon.faCalendarAlt} /> Activity Calendar</h3>
                        <div className="d-flex align-items-center">
                            <button type="button" className="btn btn-secondary" onClick={() => toggleFilterForm(!filterFormVisible)}>
                                Change Filter
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const reportFilterFormJsx = () => {
        return (
            <form onSubmit={reportFilterFormSubmit} className='py-3'>
                <div className='row mb-3' style={{ zIndex: 3, position: "relative" }}>
                    <label className="col-sm-3 col-form-label col-form-label-sm text-end">Site</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={formData.allSites}
                            changeEvent={o => setFormData(d => ({
                                ...d,
                                filterData: { ...d.filterData, search_site_ids: o.map(e => e.value) }
                            }))}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={formData.allSites.filter(s => formData.filterData.search_site_ids.includes(s.value))}
                            placeholder="Select Site"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="pb-3 col-9 text-end">
                        <button type="submit" disabled={loading} className="btn btn-primary px-4">
                            Submit
                        </button>
                    </div>
                </div>
            </form>
        );
    };

    const getEventStyle = (event) => {
        const colors = {
            'scs': '#45BEA9',
            'compliance': '#3498db',
            'po': '#dfa878',
            'tickets': '#e6786c',
            'project_tickets': '#e6786c',
            'tentative': '#db7ad3',
            'wo_due_date': '#db7ad3',
            'employee_compliance': '#eed676'
        };

        return {
            style: {
                backgroundColor: colors[event.eventType] || '#3174ad',
                borderRadius: '4px',
                color: 'white',
                border: 'none',
                cursor: 'pointer'
            }
        };
    };

    const summaryData = getDateWiseSummary();

    const filteredSummaryData = selectedSummaryDate
        ? summaryData.filter(
            item => item.date === selectedSummaryDate
        )
        : summaryData;
    return (
        <ApplicationLayout>
            {pageTitleBarJsx()}
            <div className="container-fluid pl5">
                <div className='page_containt row'>
                    <div id="pageTbl" className="pageTbl col-sm-12 pb-3">
                        <div className={["bg-white", filterFormVisible ? 'tbShow' : 'tbHide'].join(" ")}>
                            {reportFilterFormJsx()}
                        </div>

                        {reportSubmitted && (
                            <>
                                {formSearchedElems.length > 0 && (
                                    <div style={{ position: "sticky", top: "0px", zIndex: 2, background: "#fff", borderBottom: "1px solid #e5e5e5" }}>
                                        <DisplaySearchCriteria searchedElems={formSearchedElems} />
                                    </div>
                                )}
                                <div className="row">
                                    <div className='pr0 col-sm-8' style={{ background: 'white', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
                                        <div className="card col-sm-12">
                                            <div className="card-body">
                                                <div className="row align-items-center justify-content-between mb-3 mt-2">
                                                    <div className="col-5">
                                                        <button className="btn me-1" style={{ backgroundColor: '#45BEA9', borderColor: '#45BEA9', color: 'white' }} onClick={handleBack}>
                                                            Back
                                                        </button>
                                                        <button className="btn" style={{ backgroundColor: '#45BEA9', borderColor: '#45BEA9', color: 'white' }} onClick={handleNext}>
                                                            Next
                                                        </button>
                                                    </div>
                                                    <div className="text-muted fw-bold col-2 text-center">
                                                        {moment(currentDate).format('MMMM YYYY')}
                                                    </div>
                                                    <div className="text-end col-5">
                                                        <button className={`btn me-2 ${currentView === 'month' ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setCurrentView('month')}>
                                                            Month
                                                        </button>
                                                        <button className={`btn ${currentView === 'week' ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setCurrentView('week')}>
                                                            Week
                                                        </button>
                                                    </div>
                                                </div>

                                                {loading ? (
                                                    <div className="text-center py-3"><Loader /></div>
                                                ) : (
                                                    <div style={{ position: 'relative', height: "440px", zIndex: 1 }}>
                                                        <Calendar
                                                            localizer={localizer}
                                                            events={allEvents}
                                                            startAccessor="start"
                                                            endAccessor="end"
                                                            style={{ height: '100%' }}
                                                            views={['month', 'week', 'day']}
                                                            date={currentDate}
                                                            step={60}
                                                            timeslots={1}
                                                            popup
                                                            selectable
                                                            onSelectSlot={(slotInfo) => {
                                                                const clickedDate = moment(slotInfo.start).format("YYYY-MM-DD");
                                                                setSelectedSummaryDate(clickedDate);
                                                            }}
                                                            onSelectEvent={handleEventClick}
                                                            onView={onViewChange}
                                                            onNavigate={onNavigate}
                                                            onRangeChange={onRangeChange}
                                                            view={currentView}
                                                            eventPropGetter={getEventStyle}
                                                            components={{ toolbar: () => null }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                            {scsUpdatedTime && (
                                                <div className="text-muted mb-2 small px-3 pb-3">
                                                    Last updated: {scsUpdatedTime}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Date Summary Column */}
                                    <div className="col-sm-4 px-1">
                                        <div
                                            className="card"
                                            style={{
                                                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                                height: "100%"
                                            }}
                                        >
                                            <div className="d-flex justify-content-between align-items-center mx-2 pt-2">
                                                <h6 className="mb-0">Date Summary</h6>
                                                {selectedSummaryDate && (
                                                    <button
                                                        className="btn btn-sm btn-outline-secondary me-2"
                                                        onClick={() => setSelectedSummaryDate(null)}>
                                                        Show All
                                                    </button>
                                                )}
                                            </div>
                                            <div
                                                className="card-body p-2 mt-1"
                                                style={{
                                                    maxHeight: "520px",
                                                    overflowY: "auto"
                                                }}
                                            >
                                                {loading ? (
                                                    <div className="text-center py-3">
                                                        <Loader />
                                                    </div>
                                                ) : filteredSummaryData.length > 0 ? (
                                                    filteredSummaryData.map((item, index) => (
                                                        <div
                                                            key={index}
                                                            className="border rounded p-2 mb-2 me-1"
                                                        >
                                                            <div className="fw-bold mb-2">
                                                                {moment(item.date).format("DD MMM YYYY")}
                                                            </div>
                                                            {item.scs > 0 && (
                                                                <div className="d-flex justify-content-between">
                                                                    <span>SCS</span>
                                                                    <span
                                                                        className={`fw-bold ${item.scs > 0 ? 'text-primary cursor_pointer' : 'text-muted'}`}
                                                                        style={{ cursor: item.scs > 0 ? 'pointer' : 'default' }}
                                                                        onClick={() => handleSummaryClick('scs', item.date, item.scs)}
                                                                    >
                                                                        {item.scs}
                                                                    </span>
                                                                </div>)}
                                                            {item.compliance > 0 && (
                                                                <div className="d-flex justify-content-between mt-1">
                                                                    <span>Asset Compliance</span>
                                                                    <span
                                                                        className={`fw-bold ${item.compliance > 0 ? 'text-primary cursor_pointer' : 'text-muted'}`}
                                                                        onClick={() => handleSummaryClick('compliance', item.date, item.compliance)}
                                                                        style={{ cursor: item.compliance > 0 ? 'pointer' : 'default' }}
                                                                    >
                                                                        {item.compliance}
                                                                    </span>
                                                                </div>)}
                                                            {item.po > 0 && (
                                                                <div className="d-flex justify-content-between mt-1">
                                                                    <span>PO</span>
                                                                    <span
                                                                        className={`fw-bold ${item.po > 0 ? 'text-primary cursor_pointer' : 'text-muted'}`}
                                                                        onClick={() => handleSummaryClick('po', item.date, item.po)}
                                                                        style={{ cursor: item.po > 0 ? 'pointer' : 'default' }}
                                                                    >
                                                                        {item.po}
                                                                    </span>
                                                                </div>)}
                                                            {item.tickets > 0 && (
                                                                <div className="d-flex justify-content-between mt-1">
                                                                    <span>Tickets</span>
                                                                    <span className={`fw-bold ${item.tickets > 0 ? 'text-primary cursor_pointer' : 'text-muted'}`}
                                                                        onClick={() => handleSummaryClick('tickets', item.date, item.tickets)}>
                                                                        {item.tickets}
                                                                    </span>
                                                                </div>)}
                                                            {item.project_tickets > 0 && (
                                                                <div className="d-flex justify-content-between mt-1">
                                                                    <span>Project Tickets</span>
                                                                    <span className={`fw-bold ${item.project_tickets > 0 ? 'text-primary cursor_pointer' : 'text-muted'}`}
                                                                        onClick={() => handleSummaryClick('project_tickets', item.date, item.project_tickets)}>
                                                                        {item.project_tickets}
                                                                    </span>
                                                                </div>)}
                                                            {item.tentative > 0 && (
                                                                <div className="d-flex justify-content-between mt-1">
                                                                    <span>Release Date</span>
                                                                    <span className={`fw-bold ${item.tentative > 0 ? 'text-primary cursor_pointer' : 'text-muted'}`}
                                                                        onClick={() => handleSummaryClick('tentative', item.date, item.tentative)}>
                                                                        {item.tentative}
                                                                    </span>
                                                                </div>)}
                                                            {item.wo_due_date > 0 && (
                                                                <div className="d-flex justify-content-between mt-1">
                                                                    <span>WO Due Date</span>
                                                                    <span className={`fw-bold ${item.wo_due_date > 0 ? 'text-primary cursor_pointer' : 'text-muted'}`}
                                                                        onClick={() => handleSummaryClick('wo_due_date', item.date, item.wo_due_date)}>
                                                                        {item.wo_due_date}
                                                                    </span>
                                                                </div>)}
                                                            {item.employee_compliance > 0 && (
                                                                <div className="d-flex justify-content-between mt-1">
                                                                    <span>Employee Compliance</span>
                                                                    <span className={`fw-bold ${item.employee_compliance > 0 ? 'text-primary cursor_pointer' : 'text-muted'}`}
                                                                        onClick={() => handleSummaryClick('employee_compliance', item.date, item.employee_compliance)}>
                                                                        {item.employee_compliance}
                                                                    </span>
                                                                </div>)}
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className="text-center text-muted py-5">
                                                        No Data Found
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>

            <ScsEventListModal
                isOpen={showScsModal}
                selectedDate={selectedScsDate}
                onClose={() => setShowScsModal(false)}
            />
            <ComplianceEventListModal
                isOpen={showComplianceModal}
                selectedDate={selectedComplianceDate}
                onClose={() => setShowComplianceModal(false)}
            />
            <PoEventListModal
                isOpen={showPoModal}
                selectedDate={selectedPoDate}
                onClose={() => setShowPoModal(false)}
            />
            <TicketsEventListModal
                isOpen={showTicketsModal}
                selectedDate={selectedTicketsDate}
                onClose={() => setShowTicketsModal(false)}
            />

            <ProjectTicketsEventListModal
                isOpen={showProjectTicketsModal}
                selectedDate={selectedProjectTicketsDate}
                onClose={() => setShowProjectTicketsModal(false)}
            />

            <RentalEventListModal
                isOpen={showRentalModal}
                 rentalType={selectedRentalType}
                selectedDate={selectedRentalDate}
                onClose={() => setShowRentalModal(false)}
            />

            <EmployeeComplianceEventListModal
                isOpen={showEmployeeComplianceModal}
                selectedDate={selectedEmployeeComplianceDate}
                onClose={() => setShowEmployeeComplianceModal(false)}
            />
            <RunningStatusViewModal ref={RunningStatusModalRef} />
        </ApplicationLayout>
    );
};

export default ActivityCalendar;